import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import About from './views/About.vue'
import Wishlist from './views/Wishlist.vue'
import Layouts from './views/Layouts.vue'
import Property from './views/Property.vue'
import Search from './views/Search.vue'
import NotFound from './views/NotFound.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/wishlist',
      name: 'wishlist',
      component: Wishlist
    },
    {
      path: '/layouts',
      name: 'layouts',
      component: Layouts,
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/property/:id',
      component: Property,
      name: "property"
    },
    {
      path: '/search',
      component: Search,
      name: "search",
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '*',
      component: NotFound,
      name: "notFound"
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (to.name === 'property') {
        return { x: 0, y: 0 }
      }
    }
  },
})

export default router